<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="@/assets/images/retailer_logo.png" class="logo medium" />
      </a>
    </div>
    <div class="navbar-menu">
      <div class="navbar-start">
        <a
          class="navbar-item"
          href="#"
          v-for="(menu, index) in menuItems"
          :key="index"
          @mouseover="
            hover = true;
            showSubMenu = true;
          "
          @mouseleave="
            hover = false;
            showSubMenu = false;
          "
        >
          {{ menu.name }}
          <div :class="hover ? 'navbar-submenu' : 'navbar-submenu-hidden'">
            <ul>
              <li
                v-on:click="selectMenu(`${menu.name}'s ${submenu}`)"
                v-for="(submenu, ind) in menu.items"
                :key="ind"
              >
                {{ submenu }}
              </li>
            </ul>
          </div>
        </a>
        <a class="navbar-item" href="#"> Men </a>
        <a class="navbar-item" href="#"> Kids </a>
        <a class="navbar-item" href="#"> Home &amp; Gifts </a>
      </div>
      <div class="navbar-end">
        <a class="navbar-item" href="#"> Search </a>
        <a v-if="this.contact" class="navbar-item prospect" href="#">
          {{ contact.name }} ({{ contact.company }})
        </a>
        <a v-else class="navbar-item" href="#"> Sign In </a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "RetailerNavBar",
  props: {
    contact: Object,
  },
  data: function () {
    return {
      menuItems: [
        {
          name: "Women",
          items: ["Tops", "Dresses", "Pants", "Jeans", "Jackets", "Sweaters"],
        },
      ],
      showSubMenu: true,
      hover: false,
    };
  },
  methods: {
    selectMenu: function (menu) {
      this.hover = false;
      this.$emit("submenu-selected", menu);
    },
  },
};
</script>

<style scoped lang="scss">
.navbar {
  padding: 0;
  div.navbar-start {
    @media screen and (min-width: 1850px) {
      margin-left: 8.5rem;
    }
  }
  a.navbar-item {
    position: relative;
    &:focus,
    &:active {
      color: #131313;
      background: none;
      border: none;
    }
    &:hover {
      color: #23d160;
      background: none;
      border: none;
      .navbar-sub-menu {
        display: block;
      }
    }
    img {
      max-height: 3.25em;
    }
    .navbar-submenu,
    .navbar-submenu-hidden {
      position: absolute;
      left: 0;
      top: 0;
      width: 250px;
      z-index: 100;
      background: #fff;
      box-shadow: 0px 0px 10px rgb(204, 204, 204);
      margin-top: 4rem;
      color: #000;
      // border-radius: 5px;
      li {
        height: 40px;
        padding: 0.5rem 0.75rem;
        &:hover {
          color: #23d160;
          background: #f8f8f8;
        }
      }
    }
    .navbar-submenu-hidden {
      display: none;
    }
  }
  font-size: 1.2em;
  .prospect {
    color: #8ec740;
  }
}
</style>

  
